import api from './api';

// Client Onboarding checklist/dashboard (onboarding Module 3).
export const onboardingAPI = {
  myChecklist: () => api.get('/api/onboarding/me'),
  checklist: (clientId) => api.get(`/api/onboarding/${clientId}`),
  getSection: (clientId, key) => api.get(`/api/onboarding/${clientId}/sections/${key}`),
  saveSection: (clientId, key, data) => api.put(`/api/onboarding/${clientId}/sections/${key}`, data),
  submit: (clientId) => api.post(`/api/onboarding/${clientId}/submit`),
  reopenSection: (clientId, key) => api.post(`/api/onboarding/${clientId}/sections/${key}/reopen`),
  saveSpouse: (clientId, data) => api.post(`/api/onboarding/${clientId}/spouse`, data),
  // Related entities
  addRelatedEntity: (clientId, data) => api.post(`/api/onboarding/${clientId}/related-entities`, data),
  updateRelatedEntity: (clientId, entityClientId, data) => api.put(`/api/onboarding/${clientId}/related-entities/${entityClientId}`, data),
  removeRelatedEntity: (clientId, entityClientId) => api.delete(`/api/onboarding/${clientId}/related-entities/${entityClientId}`),
  finalizeRelatedEntities: (clientId, data) => api.post(`/api/onboarding/${clientId}/related-entities/finalize`, data),
  // Rental properties (reuses the firm-wide rental_properties collection)
  listRentals: (clientId) => api.get(`/api/onboarding/${clientId}/rental-properties`),
  addRental: (clientId, data) => api.post(`/api/onboarding/${clientId}/rental-properties`, data),
  updateRental: (clientId, propertyId, data) => api.put(`/api/onboarding/${clientId}/rental-properties/${propertyId}`, data),
  removeRental: (clientId, propertyId) => api.delete(`/api/onboarding/${clientId}/rental-properties/${propertyId}`),
  finalizeRentals: (clientId, data) => api.post(`/api/onboarding/${clientId}/rental-properties/finalize`, data),
  // Identity Verification (Didit KYC) — create a hosted session + read status
  createIdentitySession: (clientId, baseUrl) => api.post(`/api/onboarding/${clientId}/identity/session`, { base_url: baseUrl }),
  identityStatus: (clientId) => api.get(`/api/onboarding/${clientId}/identity`),
  // Document Upload Centre (Module 7) — reuses GridFS / db.documents
  documentCentre: (clientId) => api.get(`/api/onboarding/${clientId}/documents`),
  uploadDocument: (clientId, formData) => api.post(`/api/onboarding/${clientId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteDocument: (clientId, docId) => api.delete(`/api/onboarding/${clientId}/documents/${docId}`),
  finalizeDocuments: (clientId, data) => api.post(`/api/onboarding/${clientId}/documents/finalize`, data),
  downloadDocument: (docId) => api.get(`/api/documents/${docId}/download`, { responseType: 'blob' }),
};

// Document status → badge label/colour (Module 7).
export const DOC_STATUS_META = {
  required: { label: 'Required', color: 'bg-red-100 text-red-700' },
  optional: { label: 'Optional', color: 'bg-muted text-muted-foreground' },
  uploaded: { label: 'Uploaded', color: 'bg-blue-100 text-blue-800' },
  reviewed: { label: 'Reviewed', color: 'bg-purple-100 text-purple-800' },
  accepted: { label: 'Accepted', color: 'bg-green-100 text-green-800' },
  needs_clarification: { label: 'More info required', color: 'bg-orange-100 text-orange-800' },
  rejected: { label: 'Rejected', color: 'bg-red-100 text-red-800' },
};

export const RELATED_ENTITY_TYPE_OPTIONS = [
  { value: 'company', label: 'Company' },
  { value: 'trust', label: 'Trust' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'smsf', label: 'SMSF' },
  { value: 'sole_trader_abn', label: 'Sole trader ABN' },
  { value: 'investment_entity', label: 'Investment entity' },
  { value: 'other', label: 'Other' },
];

export const RELATED_ROLE_OPTIONS = [
  { value: 'director', label: 'Director' },
  { value: 'shareholder', label: 'Shareholder' },
  { value: 'trustee', label: 'Trustee' },
  { value: 'beneficiary', label: 'Beneficiary' },
  { value: 'partner', label: 'Partner' },
  { value: 'member', label: 'Member' },
  { value: 'sole_trader', label: 'Sole trader' },
  { value: 'other', label: 'Other' },
];

export const SECTION_STATUS_META = {
  not_started: { label: 'Not started', color: 'bg-muted text-muted-foreground' },
  in_progress: { label: 'In progress', color: 'bg-amber-100 text-amber-800' },
  completed: { label: 'Completed', color: 'bg-green-100 text-green-800' },
  needs_review: { label: 'Needs review', color: 'bg-orange-100 text-orange-800' },
};
